
import httpManager from "../../util/common";

export default{
    props: ["url"],
    model: {
        prop: 'input_content',
        event: 'getId'
    },
    data() {
        return {
            hints: [],            // 下拉列表提示内容
            show_hints: false,
            product_ids: [],
            fund_name: "",        // 输入时文本框的内容
            check_fund_name: "", // 选择后文本框显示内容
            check_product_id: "",
            check_product_manager: ""
        }
    },
    methods: {
      emit(val) {
        this.$emit('getId', val)
      },
      /*
        获得基金代码与基金管理人数据
      */
      getFundProduct() { 
        let self = this
        let params = new Map()
        params.set('keyword', self.fund_name)
        httpManager(this.url, params)
          .then(response => {
            if(self.url === "fund_productinfos") {
                self.hints = response.data.map(x => x.name)
                self.product_ids = response.data.map(x => x.product_id)
                self.show_hints = true
            } else if(self.url === "fund_productmanagers") {
              self.hints = response.data.map(x => x.product_manager)
              self.show_hints = true
            }
          })
      },
      fillInput (index) {
        this.showHintsBox = false
        this.closeClick = true
        let value = this.hints[index]
        this.hints = []
        this.fund_name = value
        this.check_fund_name = value
        if(this.url === "fund_productinfos"){
          this.check_product_id = this.product_ids[index]
        } else if (this.url === "fund_productmanagers") {
          this.check_product_manager = value
        }
        
      },
      closeHintsBox: function () {
        let self = this
        setTimeout(function () {
          self.showHintsBox = false
          self.hints = []
        }, 250)
      }
    },
    created() {
    },
    watch: {
      fund_name: function () {
        if (!this.closeClick) {
          if (this.fund_name === '') {
            this.check_product_id = ""
            this.check_product_manager = ""
            this.closeHintsBox()
            return
          }
          let last = this.fund_name
          setTimeout(()=>{
            if(last === this.fund_name){
              this.getFundProduct()
            }
          },500)
        } else {
          this.closeClick = false
        }
        if(!this.fund_name){
          this.check_product_id = ""
          this.check_product_manager = ""
        }
      },
      check_product_id: function() {
        this.emit(this.check_product_id)
      },
      check_product_manager: function() {
        this.emit(this.check_product_manager)
      }
    }

}


// WEBPACK FOOTER //
// ./src/fund_esg/js/fund_search.js